var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.135,
    height: 14.982,
    viewBox: "0 0 16.135 14.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-outline",
    "data-name": "Icon ionic-ios-star-outline",
    d: "M17.772,8.561h-5.3l-1.61-4.8a.583.583,0,0,0-1.095,0l-1.61,4.8H2.826a.578.578,0,0,0-.576.576.423.423,0,0,0,.011.1.554.554,0,0,0,.241.407L6.856,12.71,5.185,17.568a.578.578,0,0,0,.2.648.557.557,0,0,0,.324.14.706.706,0,0,0,.36-.13l4.25-3.029,4.25,3.029a.675.675,0,0,0,.36.13.517.517,0,0,0,.321-.14.571.571,0,0,0,.2-.648L13.775,12.71l4.318-3.1.1-.09a.551.551,0,0,0-.425-.962Zm-4.581,3.331a1.011,1.011,0,0,0-.367,1.145L13.908,16.2a.145.145,0,0,1-.22.166L10.9,14.374a1.006,1.006,0,0,0-.587-.187.988.988,0,0,0-.583.187L6.943,16.358a.144.144,0,0,1-.22-.166l1.084-3.158a1.015,1.015,0,0,0-.371-1.152L4.519,9.825A.145.145,0,0,1,4.6,9.562H8.156a1.007,1.007,0,0,0,.954-.688L10.177,5.7a.145.145,0,0,1,.274,0l1.066,3.177a1.007,1.007,0,0,0,.954.688h3.5a.142.142,0,0,1,.083.259Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#061133"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutline);
export default __webpack_public_path__ + "static/media/Icon-star-outline.367cb6cd8c06f5e7767dd2036799abc7.svg";
export { ForwardRef as ReactComponent };